/* global require, up */

/*
  listen to events and automatically render the contents of the events to the given `targets`

  [listen-for]: event name that component reacts to
  [listen-to]:  DOM element that is being listened to (will be `document` if element isn't found)
  [targets]: similar to `up-target`, but supports many and doesn't fail if some targets are not found

  example:
  // <auto
  //   listen-for="carousel:change-slide"
  //   listen-to="carousel-container"
  //   targets="idx">
  //   <div class="ui top right attached label massive">
  //     slides:
  //     <idx> 1 </idx>
  //     /
  //     <count> {{renders|count}}</count>
  //   </div>
  // </auto>

  in this case, `target="idx"` refers to `<idx></idx>` and the DOM node will update its contents with the event value {idx: <value>}
*/

function auto_compiler(element, data){
  const listen_to  = up.element.attr(element, "listen-to")
  const listen_for = up.element.attr(element, "listen-for")
  const targets    = up.element.attr(element, "targets")?.split(",")

  if (!listen_for) {
    console.error("there is no event for the auto to listen for")
    return
  }

  if (!listen_to) {
    console.error("there is no specifiec emitter for the auto to listen to")
    return
  }

  if (!targets) {
    console.warn("there are no event/dom targets for the auto to react to, will use DOM tagnames as targets")
    // return
  }

  function render(event){
    //console.log(event, Object.keys(event))

    let auto_targets = targets ? targets : Object.keys(event)

    auto_targets.forEach(target => {
      const event_val = event[target]
      if (event_val){
        const el = element.querySelector(target)
        if(el){
          el.innerHTML = event_val
        }
      }
    })
  }

  if(listen_to){
    const emitter = element.closest(listen_to) || document.querySelector(listen_to)
    //console.log("auto: listening to", emitter, "for", listen_for, "events")
    return up.on(emitter, listen_for, render)
  }
  else {
    return up.on(listen_for, render)
  }
}

up.compiler("auto", auto_compiler)
up.compiler("[auto]", auto_compiler)
